import type { ActivityIcon } from './activityIcons'
import type { PlanCategory } from './geo'

/** Which activity icon each example plan uses. */
export const PLAN_ICON: Record<string, ActivityIcon> = {
  p1: 'badminton', p2: 'guitar', p3: 'dice', p4: 'run', p5: 'cricket', p6: 'momo', p7: 'chai', p8: 'tt',
  p9: 'headphones', p10: 'mic', p11: 'yoga', p12: 'tt', p13: 'football', p14: 'chai', p15: 'book', p16: 'chess',
  p17: 'mic', p18: 'bike', p19: 'tt', p20: 'momo', p21: 'sketch', p22: 'volley', p23: 'trail', p24: 'darts',
}

export type Filter = 'all' | 'wf' | PlanCategory
export const FILTERS: { id: Filter; label: string }[] = [
  { id: 'all', label: 'All' }, { id: 'racquet', label: 'Racquet' }, { id: 'team', label: 'Team sports' },
  { id: 'music', label: 'Music' }, { id: 'food', label: 'Food' }, { id: 'games', label: 'Games' },
  { id: 'fitness', label: 'Fitness' }, { id: 'talks', label: 'Talks' }, { id: 'wf', label: 'Women-first' },
]

/** Header links. `spy` is the section id watched on the home page; Advertise is its own page. */
export const NAV_LINKS = [
  { id: 'top', label: 'Home', to: '/', spy: 'top' },
  { id: 'explore', label: 'Explore', to: '/#explore', spy: 'explore' },
  { id: 'host', label: 'Host', to: '/#host', spy: 'host' },
  { id: 'advertise', label: 'Advertise', to: '/advertise', spy: null },
  { id: 'safety', label: 'Safety', to: '/#safety', spy: 'safety' },
] as const
export type NavId = (typeof NAV_LINKS)[number]['id']

export const CITIES = ['Delhi NCR', 'Mumbai', 'Bengaluru', 'Hyderabad', 'Pune', 'Chennai', 'Kolkata', 'Ahmedabad', 'Jaipur', 'Chandigarh', 'Kochi', 'Indore'] as const
export const FIRST_CITY = 'Delhi NCR'

export const PARTNER_EMAIL = 'collab@getmauj.com'
export const HELLO_EMAIL = 'hello@getmauj.com'

/** Official social profiles. Shown in the footer and listed in index.html (Organization "sameAs"). */
export const SOCIALS = [
  { id: 'instagram', label: 'Instagram', handle: '@getmauj', href: 'https://www.instagram.com/getmauj/' },
  { id: 'x', label: 'X', handle: '@getmauj', href: 'https://x.com/getmauj' },
  { id: 'linkedin', label: 'LinkedIn', handle: 'getmauj', href: 'https://www.linkedin.com/company/getmauj/' },
] as const
export type SocialId = (typeof SOCIALS)[number]['id']

/** Optional form endpoints. Without them, forms open the visitor's email app with the details filled in. */
// One URL (VITE_FORMS_ENDPOINT, e.g. the Google Sheets script) can serve both forms; each can also be set separately.
const FORMS_ENDPOINT = import.meta.env.VITE_FORMS_ENDPOINT ?? ''
export const WAITLIST_ENDPOINT: string = import.meta.env.VITE_WAITLIST_ENDPOINT || FORMS_ENDPOINT
export const PARTNER_ENDPOINT: string = import.meta.env.VITE_PARTNER_ENDPOINT || FORMS_ENDPOINT
